import { clientsListingRoutes } from './features/clients-listing/clients-listing.routes';
import { clientDetailsRoutes } from './features/client-details/client-details.routes';

export const clientsRoutes = [
  {
    path: '/clients',
    name: 'clients',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "clients" */ './Clients'),
    children: [...clientsListingRoutes, ...clientDetailsRoutes]
  }
];
